import { Pipe, PipeTransform } from '@angular/core'
@Pipe({ name: 'price' })
export class PricePipe implements PipeTransform {
  transform(value: number): any {
    if (value === null) {
      return null
    } else if (value > 0) {
      return value.toFixed(2)
    } else {
      return '-'
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/pipe/price.pipe.ts